import { Modal, Button } from "@mui/material"
import MDBox from "../MDBox"
import MDTypography from "../MDTypography"

const ModalLeaveAlert = (props) => {
  const { isOpen, onClose, onSubmit, isAlertHoliday } = props

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-alert-container">
        <div className="modal-leave-alert-container-wrapper">
          <MDBox className="modal-leave-alert-header">
            <MDBox>
              <MDTypography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                Alert
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox className="modal-leave-alert-content">
            The leave request has been approved. Notification has been sent to
            the Scheduler/Teacher.
          </MDBox>
          <MDBox className="modal-leave-alert-footer">
            <Button
              className="submit-button"
              variant="contained"
              color="primary"
              onClick={onSubmit}
              sx={{ width: "100%" }}
            >
              Close
            </Button>
          </MDBox>
        </div>
      </div>
    </Modal>
  )
}

export default ModalLeaveAlert
